import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import _ from 'lodash';

export enum ranges {
	Week = 'Week',
	Month = 'Month',
	Quorter = 'Quorter',
}

export interface currencyRateParams {
	currency: string;
	range: ranges;
}

interface currencyRateState extends currencyRateParams {
	loading: boolean;
	rates: unknown[];
	error: boolean;
}

const initialState: currencyRateState = {
	loading: true,
	rates: [],
	error: false,
	currency: 'GBP',
	range: ranges.Quorter,
};

export const currencyRateSlice = createSlice({
	name: 'currencyRate',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setError: (state, action: PayloadAction<boolean>) => {
			state.error = action.payload;
		},
		setRates: (state, action: PayloadAction<unknown[]>) => {
			state.rates = action.payload;
		},
		setRange: (state, action: PayloadAction<ranges>) => {
			state.range = action.payload;
		},
		setCurrency: (state, action: PayloadAction<string>) => {
			state.currency = action.payload;
		},
	},
});

export const { setLoading, setError, setRates, setRange, setCurrency } = currencyRateSlice.actions;

export const getCurrencyRange = (state: any) => {
	return state.currencyRate.range;
};

export const getCurrencyCode = (state: any) => {
	return state.currencyRate.currency;
};

export const getCurrencyRate = (state: any) => {
	return state.currencyRate.rates;
};

export default currencyRateSlice.reducer;
